import moment from 'moment'

class BorrowerDetailsController {
  /*@ngInject*/
  constructor($stateParams, borrowersRepository) {
    this.name = 'borrower-details'
    this.id = $stateParams.id
    this.borrowersRepository = borrowersRepository

    this.sectors = [
      'Agriculture, Forestry and Fishing',
      'Mining',
      'Manufacturing',
      'Electricity, Gas, Water and Waste Services',
      'Construction',
      'Wholesale Trade',
      'Retail Trade',
      'Accommodation and Food Services',
      'Transport, Postal and Warehousing',
      'Information Media and Telecommunications',
      'Financial and Insurance Services',
      'Rental, Hiring and Real Estate Services',
      'Professional, Scientific and Technical Services',
      'Administrative and Support Services',
      'Public Administration and Safety',
      'Education and Training',
      'Health Care and Social Assistance',
      'Arts and Recreation Services',
      'Other Services'
    ]

    this.categories = [
      'Company', 'Trust', 'Sole Trader', 'Partnership'
    ]

    this.regions = [
      'ACT', 'QLD', 'NSW', 'NT', 'SA', 'TAS', 'VIC', 'WA'
    ]

    this.$onInit = () => {
      this.borrowersRepository.getById(this.id).then((borrower) => {
        this.borrower = borrower
      })
    }
  }

  get tradingSince() {
    return this.borrower ? moment(this.borrower.tradingSince).year() : null
  }

  set tradingSince(value) {
    this.borrower.tradingSince = value + '-01-01'
  }

  save() {
    return this.borrower.save()
  }
}

export default BorrowerDetailsController
